// The API stores thresholds as a fraction of 1 (0.10 = 10%, bounded to
// [0, 1]) with up to 4 decimal places. The UI shows/accepts a percentage
// with up to 2 decimal places so the round trip through /100 and *100 never
// loses precision or exceeds the API's 4 decimal places.
export const THRESHOLD_PATTERN = /^\d{1,3}(\.\d{1,2})?$/;
export const THRESHOLD_MAX_PERCENT = 100;

export const isValidThresholdPercent = (value: string): boolean => {
  const trimmed = value.trim();
  return THRESHOLD_PATTERN.test(trimmed) && Number(trimmed) <= THRESHOLD_MAX_PERCENT;
};

export const percentToFraction = (percent: string): string => (Number(percent.trim()) / 100).toFixed(4);

export const fractionToPercent = (fraction?: string | null): string =>
  fraction === null || fraction === undefined || fraction === ''
    ? ''
    : Number((Number(fraction) * 100).toFixed(4)).toString();

export type DailyNavThresholdKey =
  | 'cap_iq_one_day_delta'
  | 'cap_iq_five_day_delta'
  | 'cap_iq_since_last_valuation_delta'
  | 'secondary_one_day_delta'
  | 'secondary_five_day_delta'
  | 'secondary_since_last_valuation_delta';

export type DailyNavThresholdField = {
  key: DailyNavThresholdKey;
  label: string;
};

export type DailyNavThresholdGroup = {
  title: string;
  fields: DailyNavThresholdField[];
};

export const DAILY_NAV_THRESHOLD_GROUPS: DailyNavThresholdGroup[] = [
  {
    title: 'Capital IQ',
    fields: [
      { key: 'cap_iq_one_day_delta', label: '1-Day Δ' },
      { key: 'cap_iq_five_day_delta', label: '5-Day Δ' },
      { key: 'cap_iq_since_last_valuation_delta', label: 'Since Last Valuation Δ' },
    ],
  },
  {
    title: 'Secondary Transaction',
    fields: [
      { key: 'secondary_one_day_delta', label: '1-Day Δ' },
      { key: 'secondary_five_day_delta', label: '5-Day Δ' },
      { key: 'secondary_since_last_valuation_delta', label: 'Since Last Valuation Δ' },
    ],
  },
];

export const DAILY_NAV_THRESHOLD_KEYS: DailyNavThresholdKey[] = DAILY_NAV_THRESHOLD_GROUPS.flatMap(group =>
  group.fields.map(field => field.key)
);

export const DAILY_NAV_FIRM_DEFAULTS_COPY =
  'The defaults can be superseded at a company level. If no threshold is set at the company level, these defaults will be used.';
